import {BitmapText, IBitmapTextStyle, Rectangle} from "pixi.js";
import {DrawFrmThing} from "../../drawfrm/DrawFrmThing";
import {ElevationApp} from "../../ElevationApp";
import {inches, lineBlueHeavy} from "../../const";
import {AngleEditor, formatAngle} from "../../components/AngleEditor";

const TEXT_STYLE: Partial<IBitmapTextStyle> = {
    fontName: "Arial",
    fontSize: 40,
};

// the leader from the head's top edge up to the label.
const LEADER_LENGTH = 1.5 * inches;
const LEADER_GAP = 0.5 * inches;

// the plan angle of an angled mullion (see MdFrameStick.angle), drawn above the frame
// over the stick as "90 deg" on a short leader. A tap on the text opens the angle
// editor; the owner commits the value through `onSet`.
export class StickAngleDimension extends DrawFrmThing {
    private elev: ElevationApp;
    private label: BitmapText;
    private onSet: (deg: number) => void;
    private deg = 0;

    constructor(elev: ElevationApp, onSet: (deg: number) => void) {
        super();
        this.elev = elev;
        this.onSet = onSet;

        const t = new BitmapText("", TEXT_STYLE);
        t.anchor.set(0.5, 1);
        t.tint = lineBlueHeavy;
        t.eventMode = "static";
        t.cursor = "pointer";
        t.on("pointertap", e => {
            e.stopPropagation();
            this.openEditor();
        });
        this.graphic.addChild(t);
        this.label = t;
    }

    // place the label over the stick centre `x`, standing on the frame's top edge `top`
    // (both in the owner's container space).
    draw(x: number, top: number, deg: number) {
        this.deg = deg;
        this.graphic.position.set(x, top);

        const label = this.label;
        label.text = formatAngle(deg) + " deg";
        label.position.set(0, -LEADER_LENGTH - LEADER_GAP);
        // hit-test the text's box so taps in the whitespace between letters register.
        label.hitArea = new Rectangle(-label.width * 0.5, -label.height, label.width, label.height);

        const g = this.lines;
        g.clear();
        this.elev.draw.setDimensionLineStyle(g, lineBlueHeavy);
        g.moveTo(0, 0);
        g.lineTo(0, -LEADER_LENGTH);
    }

    openEditor() {
        if(this.elev.readOnly) return;
        const t = this.label;
        if(this.destroyed || t.destroyed) return;

        this.elev.draw.showReact({
            render: opts => (
                <AngleEditor
                    value={this.deg}
                    onDone={deg => {
                        opts.remove();
                        this.onSet(deg);
                    }}
                    onCancel={() => opts.remove()}
                />
            ),
            anchor: () => t.getGlobalPosition(),
        });
    }
}
